import React from 'react'

import { LntButton, LntModal, LntForm, LntFormItem, LntSelect, LntModalFooter } from '@app/components/base'

import { LOCATION_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getCompetitors } from '@app/api/routes/locationCompetitors'

import { getFilterCompetitorsFormEntities } from '@app/utils/entitiesAdapters'

import type { RestartMonitoringTaskModalProps } from './types'

const DEFAULT_TITLE = 'Вы уверены, что хотите перезапустить мониторинг?'

export const RestartMonitoringTaskModal: React.FC<RestartMonitoringTaskModalProps> = props => {
  const { onSubmit, title, ...restProps } = props

  const modalTitle = title ?? DEFAULT_TITLE

  return (
    <LntModal
      { ...restProps }
      title={ modalTitle }
      footer={ null }
      width={ 444 }
    >
      <LntForm
        layout='vertical'
        onSubmit={ onSubmit }
      >
        <LntFormItem
          name='competitorIds'
          label='Выберите сеть конкурента'
          defaultValue={ [] }
          validationOptions={ { rules: { required: 'Выберите хотя бы одну сеть' } } }
        >
          <LntSelect
            showArrow
            mode='multiple'
            size={ SIZE.middle }
            placeholder={ FILTERS_PLACEHOLDERS.competitorsAddressesFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationCompetitorsNetworksItems],
              queryFn: getCompetitors,
              select: getFilterCompetitorsFormEntities
            } }
          />
        </LntFormItem>

        <LntModalFooter>
          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
          >
            Перезапустить
          </LntButton>
        </LntModalFooter>
      </LntForm>
    </LntModal>
  )
}
